// @flow

import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {LayoutState} from 'redux/uiState/layout/LayoutState';

import {combineReducers} from 'redux';

import {baseReducer} from 'redux/uiState/layout/base/reducer';
import {bookingReducer} from 'redux/uiState/layout/booking/reducer';

export const layoutReducer: Reducer<LayoutState> = combineReducers({
  base: baseReducer,
  booking: bookingReducer,
});
